import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";
import { NotEmptyString } from "../../../../Validation/Validation";
import { EntityNames } from "../../../../enums/EntityNames";

export const CaseMaterialTypesSchema: ISchema = {
    displayName: "Material Type",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'categoryName',
            displayName: 'Category',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            className: "small-12"
        } as ISchemaProperty,
        {
            name: 'categoryId',
            displayName: 'Category',
            type: PropertyTypes.selectByEntityName,
            entityName: EntityNames.caseMaterialTypes,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
        } as ISchemaProperty,
        {
            name: 'typeName',
            displayName: 'Type Name',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Type name must be provided",
            className: "small-12"
        } as ISchemaProperty,
    ],
}
